export default class ObjectEncoder {

    private static _ENCODE_IDENTIFIER_OBJECT = 'o';
    private static _ENCODE_IDENTIFIER_ARRAY = 'a';

    public static encode(object: object): string {
        let values = [];

        if (Array.isArray(object)) {
            values.push(ObjectEncoder._ENCODE_IDENTIFIER_ARRAY);

            for (let value of object) {
                values.push(encodeURIComponent(value));
            }
        } else {
            values.push(ObjectEncoder._ENCODE_IDENTIFIER_OBJECT);

            Object.keys(object).forEach(function(key) {
                values.push(encodeURIComponent(key) + ':' + encodeURIComponent(object[key]));
            });
        }

        return values.join('|');
    }

    public static decode(object: string): string[] | object {
        let values = object.split('|');

        if (values.length == 0) {
            throw new Error('Object is empty');
        }

        if (values[0] == ObjectEncoder._ENCODE_IDENTIFIER_ARRAY) {
            values.shift();
            let newArray = [];

            for (let value of values) {
                newArray.push(decodeURIComponent(value));
            }

            return newArray;
        } else if (values[0] == ObjectEncoder._ENCODE_IDENTIFIER_OBJECT) {
            values.shift();
            let newObject = {};

            for (let value of values) {
                let pair = value.split(':');
                if (pair.length != 2) {
                    throw new Error('Object has no key');
                }

                newObject[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }

            return newObject;
        }

        throw new Error('No identifier found');
    }
}
